import { render, staticRenderFns } from "./specialPriorityList_v2.vue?vue&type=template&id=5aa5967c&scoped=true&"
import script from "./specialPriorityList_v2.vue?vue&type=script&lang=js&"
export * from "./specialPriorityList_v2.vue?vue&type=script&lang=js&"
import style0 from "./specialPriorityList_v2.vue?vue&type=style&index=0&id=5aa5967c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa5967c",
  null
  
)

export default component.exports